import { usePlanContext } from "../../../../auth/planProvider/PlanProvider";
import { useUserContext } from "../../../../auth/userContextProvider/UserContextProvider";
import { useAiFeatureAccess } from "../../../../plan/aiFeatureGate/useAiFeatureAccess";
import { useAiSpendingWarning } from "../../../../aiAdministration/AiAdministration.hooks";
import { isAiSpendingExhausted } from "../../../../aiAdministration/AiAdministration.types";
import { getObligationExtractionBlockedTranslationKey } from "./obligationExtractionAccess";

/**
 * Whether to offer "find obligations with AI" at all, and why it is disabled when it is.
 *
 * A missing add-on leaves the action visible so the customer can see what buying it would give them,
 * which is what showAffordance is for, so add-on state belongs in the blocked reason and not in the
 * visibility. Only a missing edit permission hides the action, since a permission is nothing we can
 * sell them.
 */
export function useObligationExtractionAffordance() {
    const { addonsFeatures } = usePlanContext();
    const { permissions } = useUserContext();
    const { showAffordance, planActivated: hasAiFeaturesAddOn } = useAiFeatureAccess();
    const { data: aiSpendingWarning } = useAiSpendingWarning();
    const spendingExhausted = isAiSpendingExhausted(aiSpendingWarning);

    return {
        showObligationExtraction: showAffordance && permissions.contractManagementPermissions.permissions.edit,
        blockedTranslationKey: getObligationExtractionBlockedTranslationKey({
            hasAiFeaturesAddOn,
            hasObligationsAddOn: addonsFeatures.obligations,
            isAiSpendingExhausted: spendingExhausted,
        }),
        isAiSpendingExhausted: spendingExhausted,
    };
}
